import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ComputeCapacityPlanMutationVariables = Types.Exact<{
  input: Types.ComputeCapacityPlanInput;
}>;


export type ComputeCapacityPlanMutation = { __typename?: 'Mutation', computeCapacityPlan: { __typename?: 'ComputeCapacityPlanPayload', capacityPlanRun?: { __typename?: 'CapacityPlanRun', id: any, status: Types.CapacityPlanRunStatus, queuedAt?: any | null, solveProgress: { __typename?: 'CapacityPlanSolveProgress', total: number, queued: number, computing: number, computed: number, failed: number } } | null, errors?: Array<{ __typename?: 'CapacityPlanUserError', code: Types.CapacityPlanErrorCode, message: string, runId?: any | null }> | null } };


export const ComputeCapacityPlanDocument = gql`
    mutation ComputeCapacityPlan($input: ComputeCapacityPlanInput!) {
  computeCapacityPlan(input: $input) {
    capacityPlanRun {
      id
      status
      queuedAt
      solveProgress {
        total
        queued
        computing
        computed
        failed
      }
    }
    errors {
      ... on CapacityPlanUserError {
        code
        message
        runId
      }
    }
  }
}
    `;
export type ComputeCapacityPlanMutationFn = Apollo.MutationFunction<ComputeCapacityPlanMutation, ComputeCapacityPlanMutationVariables>;

/**
 * __useComputeCapacityPlanMutation__
 *
 * To run a mutation, you first call `useComputeCapacityPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeCapacityPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeCapacityPlanMutation, { data, loading, error }] = useComputeCapacityPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useComputeCapacityPlanMutation(baseOptions?: Apollo.MutationHookOptions<ComputeCapacityPlanMutation, ComputeCapacityPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ComputeCapacityPlanMutation, ComputeCapacityPlanMutationVariables>(ComputeCapacityPlanDocument, options);
      }
export type ComputeCapacityPlanMutationHookResult = ReturnType<typeof useComputeCapacityPlanMutation>;
export type ComputeCapacityPlanMutationResult = Apollo.MutationResult<ComputeCapacityPlanMutation>;
export type ComputeCapacityPlanMutationOptions = Apollo.BaseMutationOptions<ComputeCapacityPlanMutation, ComputeCapacityPlanMutationVariables>;